module.exports = __webpack_public_path__ + "media/images/PINGPONG-929928da247ae16e29425f3caa245f0a.svg";